<template>
	<div class="newsletter-form">
		<div class="newsletter-form__top">
			<div class="newsletter-form__title">
				<h2 class="">{{context.title}}</h2>
			</div>
			<div class="newsletter-form__text wysiwyg" v-html="context.text"></div>
		</div>

		<div class="newsletter-form__success" v-if="success" v-html="this.successMessage">
		</div>

		<form v-on:submit="submitForm" method="post" action="https://nyhetsbrev.lillateatern.fi/account">
			<div class="newsletter-form__inner">
				<div class="newsletter-form__inner-fields">
					<input name="email"
						   type="email"
						   class="newsletter-form__field"
						   v-model="email"
						   v-bind:placeholder="context.translations.newsletter_form_placeholder"
					>
					<button type="submit"
							class="lillan-button newsletter-form__button"
							v-bind:disabled="loading"
					>
						{{context.translations.newsletter_form_submit_button}}
					</button>
				</div>
			</div>
			<div class="newsletter-form__consent">
				<div class="cst-checkbox">
					<label class="cst-checkbox-label">
						<input type="checkbox" class="cst-checkbox-input" name="consent[]" value="1899-1-se">
						<span class="cst-checkbox-custom-checkbox"></span>
						<span class="cst-checkbox-custom-label">
						{{context.translations.newsletter_form_consent}}
						</span>
					</label>
				</div>
			</div>
		</form>
	</div>
</template>

<script>
	export default {
		props: ['context'],
		data: function() {
			return {
				email: '',
				success: false,
				loading: false,
			}
		},
		methods: {
			submitForm(event) {
				this.loading = true;
			}
		}
	}
</script>
